import { gql } from '@apollo/client'

export default gql(`
query($limit: Int $project: String) {
    listCountry( 
    project: $project
    limit: $limit
    ){
        totalCount
        items {
          id
          name
          source
        }
      }
}`)
